import { render } from "./BasicUsage.vue?vue&type=template&id=7bde569b"
import script from "./BasicUsage.vue?vue&type=script&lang=js"
export * from "./BasicUsage.vue?vue&type=script&lang=js"
script.render = render

export default script